import Api from "@/modules/promocodes/pages/shops/services/Api"

export default {
    data: {
        title: "Создание связи магазина к компании",
        btn: "Создать",
        page: "create",
    },
    action: ({modal, payload}) => {
        return new Promise((resolve, reject) => {
            return Api.addLink(payload).then(() => {
                modal.hide();
                resolve("Связь создана")
            }).catch(() => {
                reject("Ошибка при создании связи")
            }).finally(() => {})
        })
    }
}